import { Address } from './address';
import { AutoEletricProvidedService } from './auto-eletric-provided-service';
import { Technician } from './technician';

export class AutoEletric {
  public address: Address;
  public cnpj: string;
  public deaccredited = false;
  public deleted: boolean;
  public deliveryAddress: any;
  public disqualificationReason: string;
  public extraNight: number;
  public freeCoverageRadius: number;
  public id: number;
  public kmCost: number;
  public moveValue: number;
  public name: string;
  public takeDifference = false;
  public takeMode: string;
  public technicians: Array<Technician>;
  public autoEletricServices: Array<AutoEletricProvidedService>;

  constructor() { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/auto-eletric.ts